import Vue from 'vue'
import Router from 'vue-router'

//车辆 管理///////////////////////////////
const sellitem = () => import("@/components/sell_car/sell_car"); //销售车辆
const sellplan = () => import("@/components/sell_car/sell_plan"); //销售计划
const sellclient = () => import("@/components/sell_car/sell_client"); //销售客户
const sellsheet = () => import("@/components/sell_car/sell_sheet"); //销售订单

const paysheet = () => import("@/components/sell_car/pay_sheet"); //收款计划

const paysheetpass = () => import("@/components/sell_car/pay_sheet_pass"); //收款计划审核
const paydetailpass = () => import("@/components/sell_car/pay_detail_pass"); //收款明细特殊审核

const paydetailtotal = () => import("@/components/sell_car/pay_detail_total"); //收款明细合计
const paydetaillist = () => import("@/components/sell_car/pay_detail_list"); //收款明细流水

const paysheetend = () => import("@/components/sell_car/pay_sheet_end"); //收款计划



Vue.use(Router)

export default [{
		name: "sellitem",
		path: "/sellitem",
		component: sellitem,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "销售车辆"
		}
	},
	{
		name: "sellplan",
		path: "/sellplan",
		component: sellplan,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "销售计划"
		}
	},
	{
		name: "sellclient",
		path: "/sellclient",
		component: sellclient,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "销售客户"
		}
	},
	{
		name: "sellsheet",
		path: "/sellsheet",
		component: sellsheet,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "销售订单"
		}
	},
	{
		name: "paysheet",
		path: "/paysheet",
		component: paysheet,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "收款计划"
		}
	},	
	{
		name: "paysheetpass",
		path: "/paysheetpass",
		component: paysheetpass,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "收款计划审核"
		}
	},
	{
		name: "paydetailpass",
		path: "/paydetailpass",
		component: paydetailpass,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "收款明细特审"
		}
	},
	{
		name: "paydetailtotal",
		path: "/paydetailtotal",
		component: paydetailtotal,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "收款明细合计"
		}
	},
	{
		name: "paydetaillist",
		path: "/paydetaillist",
		component: paydetaillist,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "收款明细流水"
		}
	},
	{
		name: "paysheetend",
		path: "/paysheetend",
		component: paysheetend,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "终止计划"
		}
	}

]